import styled from 'styled-components';

import { Div, FlexCol, P } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

export const SampleInsuranceCard = styled(Div)`
  background: ${colors.nickel};
  padding: 20px 20px 10px;
  border: 1px solid ${colors.silver};
  border-radius: 3px;
  width: 275px;
  align-self: center;
`;

export const MemberIdHighlight = styled(FlexCol)`
  border: 2px solid #3899f9;
  background: #d2e1f3;
  padding: 5px 10px;
  border-radius: 3px;
  margin-left: -10px;
`;

export const InsuranceCardTitle = styled(P)`
  font-size: 12px;
  margin: 0 0 -2px;
`;
